<script setup lang="ts">
const {
  providers,
  getStatusMessage,
  getSocialAuthenticationURL,
} = useSocialAuthentication();

const { dispatchTrackingEvent } = useTracking();

const props = defineProps<{
  buttonPrefix: string;
  socialLoginStatus?: string;
  socialLoginHint?: string | null;
  trackAsLoginEvent?: boolean;
}>();

const socialButtonClicked = (provider: string) => {
  if (props.trackAsLoginEvent !== true) {
    return;
  }

  dispatchTrackingEvent('login', { method: provider });
};

</script>

<template>
  <div class="flex flex-col gap-4">
    <Message
      v-if="socialLoginStatus"
      severity="error"
      :closable="false"
    >
      {{getStatusMessage(socialLoginStatus, socialLoginHint)}}
    </Message>
    <a
      v-for="provider of providers"
      :key="provider.name"
      :href="getSocialAuthenticationURL(provider.name, 'login')"
      @click="socialButtonClicked(provider.name)"
    >
      <Button
        severity="secondary"
        class="w-full flex"
        :label="`${buttonPrefix} with ${provider.label}`"
        outlined
      >
        <template #icon>
          <MIcon
            class="p-icon"
            :icon="provider.icon"
          />
        </template>
      </Button>
    </a>
  </div>
</template>